import { useContext, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const initialFormData = {
  clientName: "",
  clientNumber: "",
  userType: "",
  onboardingType: "",
  onboardedBy: "",
  billing_name: "",
  allowed_ip: "",
  firstName: "",
  lastName: "",
  password: "",
  confirmPassword: "",
};

const useCreateClient = ({ Admin }) => {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const config = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [formData, setFormData] = useState(initialFormData);

  const userTypeOptions = [
    { value: "1", label: "Admin" },
    { value: "0", label: "Super User" },
    { value: "2", label: "Regular User" },
  ];

  const onboardingTypeOptions = [
    { value: "direct", label: "Direct Onboarding" },
    { value: "indirect", label: "Indirect Onboarding" },
  ];

  const validatePasswords = (password, confirmPassword) => {
    if (!password || !confirmPassword) {
      setPasswordError("");
      return true;
    }

    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return false;
    }

    setPasswordError("");
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedFormData);

    if (name === "password" || name === "confirmPassword") {
      validatePasswords(
        updatedFormData.password,
        updatedFormData.confirmPassword
      );
    }
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setPasswordError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "clientName",
      "clientNumber",
      "userType",
      "onboardingType",
      "firstName",
      "lastName",
      "password",
      "confirmPassword",
    ];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      toast.error(`Please fill all required fields`);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }

    if (!Admin?.pkid) {
      toast.error("Admin ID missing");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        userid: Admin.pkid,
        clientName: formData.clientName,
        clientNumber: formData.clientNumber,
        userType: formData.userType,
        onboardingType: formData.onboardingType,
        onboardedBy: formData.onboardedBy,
        billing_name: formData.billing_name,
        allowed_ip: formData.allowed_ip,
        firstName: formData.firstName,
        lastName: formData.lastName,
        password: formData.password,
      };

      const response = await axios.post(
        `${baseUrl}/SuperAdmin/createClient`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        resetForm();
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Create client error:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    formData,
    passwordError,

    userTypeOptions,
    onboardingTypeOptions,

    handleInputChange,
    handleSelectChange,
    handleSubmit,
    resetForm,
  };
};

export default useCreateClient;